// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const BuyingListSelector = (state: ApplicationState) => {
    return state.bunzl.pages.buyingList.buyingLists;
};

export const AssignedBuyingListSelector = (state: ApplicationState) => {
    return state.bunzl.pages.buyingList.assignedBuyingList;
};
